import styles from './A_CapsuleUserAvatar.module.css';
import A_UserAvatar from '@/components/A_Atoms/A_UserAvatar/A_UserAvatar';

interface A_CapsuleUserAvatarProps {
  avatar?: string;
}

export default function A_CapsuleUserAvatar({
  avatar,
}: A_CapsuleUserAvatarProps) {
  return (
    <div className={styles.wrapper}>
      <A_UserAvatar
        width={28}
        height={28}
        src={avatar}
        alt='Capsule User Avatar'
      />
    </div>
  );
}
